import React, { useEffect, useState } from 'react';
import { Events, publish, subscribe } from '@conversion-cloud-widget/pubsub';
import { handleKeyDown, Header, Step } from '@conversion-cloud-widget/UI';
import { Dialog, ModuleSteps } from './Steps';

const StepRouter = ({
    backgroundColor,
    chatBot,
    companyId,
    isModal,
    mode,
    size,
    skin,
    textColor,
    xPosition,
    yPosition
}) => {
    const [activeStep, setActiveStep] = useState(undefined);
    const [stepMeta, setStepMeta] = useState({
        prevStep: undefined,
        showFooter: false,
        stepCount: 1,
        stepIndex: 1,
        stepTitle: 'FAQ'
    });

    useEffect(() => {
        if (!chatBot) {
            return;
        }
    }, [chatBot]);

    // Add event listener to capture module launch
    useEffect(() => {
        subscribe(Events.MODULE_OPENED, payload => {
            if (payload.module === process.env.MODULE_NAME) {
                const { call_to_action } = payload.data.chatbot;
                setStepMeta({
                    ...stepMeta,
                    stepTitle: call_to_action
                });
                setActiveStep(ModuleSteps.Dialog);
            }
        });
    }, []);

    const handleClose = () => {
        publish(Events.MODULE_CLOSED, {
            module: process.env.MODULE_NAME,
            companyId: companyId
        });
    };

    // Props are being passed in from Step in Step.js as element gets cloned and rendered
    const ActiveStep = () => {
        const props = {
            brandPrimaryColor: backgroundColor,
            brandTextColor: textColor,
            chatBot: chatBot,
            companyId: companyId,
            greeting: chatBot.chatbot.greeting,
            handleKeyDown,
            mode,
            topics: chatBot.questions.questions,
            skin
        };

        return <Dialog {...props} />;
    };

    return chatBot && chatBot.questions.questions ? (
        <Step
            backgroundColor={backgroundColor}
            isModal={isModal}
            mode={mode}
            showFooter={stepMeta.showFooter}
            size={size}
            skin={skin}
            textColor={textColor}
            xPosition={xPosition}
            yPosition={yPosition}
        >
            <Header onCloseClick={handleClose} title={stepMeta.stepTitle}></Header>
            <ActiveStep />
        </Step>
    ) : (
        <></>
    );
};

export default StepRouter;
